import { render, staticRenderFns } from "./MedicamentosReceita.vue?vue&type=template&id=e7cf050e&"
import script from "./MedicamentosReceita.vue?vue&type=script&lang=js&"
export * from "./MedicamentosReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports